import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["required", "id", "name", "disabled"]
const _hoisted_3 = {
  disabled: "",
  value: ""
}
const _hoisted_4 = ["value"]

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectInput',
  props: {
  values: {
    type: Array<string>,
  },
  defaultValue: {
    required: false,
    type: String || Number,
  },
  required: {
    required: false,
    type: Boolean,
  },
  label: {
    type: String,
  },
  inputID: {
    type: String,
  },
  isDisabled: {
    type: Boolean,
  },
},
  emits: ["onUpdate"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

function hasRealDefault(
  defaultValue: string | number | undefined | null,
): boolean {
  return (
    defaultValue !== undefined &&
    defaultValue !== null &&
    `${defaultValue}` !== ""
  );
}

// Use "" when there is no default so the empty placeholder option is selected
// and required validation fails until the user picks a real option.
const selectedValue = ref(
  hasRealDefault(props.defaultValue) ? props.defaultValue : "",
);

function update() {
  emit("onUpdate", props.inputID, selectedValue.value);
}

// Only seed parent answers when a real default selection exists
if (hasRealDefault(props.defaultValue)) {
  update();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", {
      for: __props.inputID,
      class: "form-label"
    }, _toDisplayString(__props.label), 9, _hoisted_1),
    _withDirectives(_createElementVNode("select", {
      class: "form-select",
      onChange: update,
      required: __props.required,
      id: __props.inputID,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedValue).value = $event)),
      name: __props.inputID,
      disabled: __props.isDisabled
    }, [
      _createElementVNode("option", _hoisted_3, _toDisplayString(__props.defaultValue), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.values, (value) => {
        return (_openBlock(), _createElementBlock("option", {
          key: value,
          value: value
        }, _toDisplayString(value), 9, _hoisted_4))
      }), 128))
    ], 40, _hoisted_2), [
      [_vModelSelect, selectedValue.value]
    ])
  ]))
}
}

})